import KIAImage from '../ui/image/KIAImage';

interface CollageProps {
  title: string;
  text: string;
  images: {
    src: string;
    alt: string;
    title?: string;
    text?: string;
    link?: string;
  }[];
}

export default function Collage({ title, text, images }: CollageProps) {
  return (
    <div className="gap-0 mx-auto px-4 max-w-7xl">
      <div className="max-w-[840px] m-auto">
        <div className="mb-12 md:mb-0 max-w-[530px] w-full">
          <h2 className="text-2xl font-normal mb-3">{title}</h2>
          <p className="text-base leading-relaxed">{text}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {images.map((image, index) => (
          <div
            key={index}
            className={`${index === 0 ? 'md:mt-32 hidden md:block' : index === 1 ? 'md:mt-32' : ''} mb-8 md:mb-0`}
          >
            <div className="mb-6">
              <KIAImage
                src={image.src}
                alt={image.alt}
                height={600}
                width={500}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 400px"
                className="w-full h-auto"
              />
            </div>
            {image.title && (
              <h3 className="text-xl font-normal mb-2">{image.title}</h3>
            )}
            {image.text && (
              <p className="text-sm leading-relaxed mb-2">{image.text}</p>
            )}
            {image.link && (
              <a href={image.link} className="link-text">
                Läs mer
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
